import React from 'react';
import { Route, RouteProps } from 'react-router-dom';
import { usePageEventTracker } from '@tools/ui/hooks';
import { userStore } from '@tools/ui-stores';

interface TrackedRouteWrapperProps {
  path?: RouteProps['path'];
}

const TrackedRouteWrapper: React.FC<
  React.PropsWithChildren<TrackedRouteWrapperProps>
> = ({ path, children }) => {
  usePageEventTracker(userStore, path);
  return <>{children}</>;
};

export const TrackedRoute: React.FC<RouteProps> = (props) => {
  const { children } = props;

  return (
    <Route {...props}>
      <TrackedRouteWrapper path={props.path}>{children}</TrackedRouteWrapper>
    </Route>
  );
};

export default TrackedRoute;
